import { endpoints } from 'api/endpoints'
import { GetArrayResponse, GetOneResponse } from 'interfaces/api.interfaces'
import { CfrGroup, CfrGroupBase } from 'interfaces/api/cfrGroups.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetArrayResponse<CfrGroup> => {
  const { data: response } = await axios.request<CfrGroup[]>({
    method: 'GET',
    url: endpoints.cfrGroups.getAll(),
  })
  return response
}

const create = async (data: CfrGroupBase): GetOneResponse<CfrGroup> => {
  const { data: response } = await axios.request<CfrGroup>({
    method: 'POST',
    url: endpoints.cfrGroups.create(),
    data,
  })
  return response
}

const update = async (id: number, data: CfrGroupBase): GetOneResponse<CfrGroup> => {
  const { data: response } = await axios.request<CfrGroup>({
    method: 'PATCH',
    url: endpoints.cfrGroups.update(id),
    data,
  })
  return response
}

const remove = (id: number): Promise<void> =>
  axios.request({
    method: 'DELETE',
    url: endpoints.cfrGroups.remove(id),
  })

export const cfrGroupsApi = {
  create,
  getAll,
  update,
  remove,
}
